import { render, staticRenderFns } from "./TenderCompanies.vue?vue&type=template&id=17660a22&"
import script from "./TenderCompanies.vue?vue&type=script&lang=js&"
export * from "./TenderCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports